/* eslint-disable import/prefer-default-export */
import React, { Fragment } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { doValidate, formatePhoneNo, isEmpty, sqInchesToSqFeet, validateAddressForm } from '../common/Common'
import I18n from '../common/I18n'
import AppConfig from '../config/AppConfig'
import { formatByTimeConfig } from './common'
import { momentTime, isMomentObject } from './date_functions'
import { isOptedExpedite, showLtlOnHandFields } from './orders'
import { getValueFromArrayOfObjects } from './array_functions'
import { getLabelDescriptionForLocation } from '../components/orders/OrderTypeIcons'

export const setEditPayload = (
  data,
  currentOrder,
  currentOrg,
  suppres_schedule_dates,
  skip_warn_hawb_uniqness,
  accounts,
  levelOfServices,
  nsr,
  is_multi_driver_delivery,
  delivery_drivers_count
) => {
  const hasExpedite = isOptedExpedite(data.appointments)
  const reqAccObject = getValueFromArrayOfObjects(accounts, "code" , currentOrder.account_code);
  const reqLOSObject = getValueFromArrayOfObjects(levelOfServices, "code" , currentOrder.los);
  const delivery_date = isMomentObject(currentOrder.delivery_date, currentOrder.delivery_time, "DD-MM-YYYY");
  const delivery_time = isMomentObject(currentOrder.delivery_time, currentOrder.delivery_date, "HH:mm");
  const payload = {
    accessorials: data.accessorials,
    appointments: data.appointments,
    customer_order_id: currentOrder.id,
    custom_appt_required: currentOrder.custom_appt_required,
    custom_appt_notes: currentOrder.custom_appt_notes,
    customer_comments: currentOrder.customer_comments,
    customer_notes: currentOrder.customer_notes,
    order_weight: currentOrder.weight,
    cbm_volume : currentOrder.cbm_volume,
    weight_in_kgs : currentOrder.weight_in_kgs,
    dispatch_status: currentOrder.dispatch_status,
    mileage : currentOrder.mileage,
    customer_order_number: !isEmpty(currentOrder.customer_order_number)
      ? currentOrder.customer_order_number.toUpperCase()
      : '',
    private_notes: currentOrder.private_notes,
    quantity: currentOrder.quantity,
    warehouse_code: currentOrder.warehouse_code,
    account: currentOrder.account_code,
    los: !isEmpty(currentOrder.los) ? currentOrder.los.toUpperCase() : '',
    account_name: !isEmpty(reqAccObject) ? reqAccObject.name : '',
    account_id: !isEmpty(reqAccObject) ? reqAccObject.id : '',
    los_name: !isEmpty(reqLOSObject) ? reqLOSObject.name : '',
    // los_id: !isEmpty(reqLOSObject) ? reqLOSObject.id : '', // contracts
    appt_set: currentOrder.appt_set,
    type_of_order: currentOrder.type_of_order,
    reference_1: currentOrder.reference_1,
    reference_1_type: currentOrder.reference_1_type,
    reference_2: currentOrder.reference_2,
    reference_2_type: currentOrder.reference_2_type,
    vehicle_type:currentOrder.vehicle_type,
    is_hazardous: currentOrder.is_hazardous,
    priority : currentOrder.priority,
    special : currentOrder ? currentOrder.special : false,
    consignee_details : currentOrder.consignee_details || {},
    account_manager_emails: !isEmpty(
      currentOrder.account_manager_emails
    )
      ? currentOrder.account_manager_emails
      : "",
    service_duration: !isEmpty(currentOrder.service_duration)
      ? currentOrder.service_duration
      : '',
    received_at: !isEmpty(currentOrder.received_at_date) && !isEmpty(currentOrder.received_at_time) ? {
        date: moment.isMoment(currentOrder.received_at_date) ? currentOrder.received_at_date.format('DD-MM-YYYY') : currentOrder.received_at_date,
        time: moment.isMoment(currentOrder.received_at_time) ? currentOrder.received_at_time.format('HH:mm') : currentOrder.received_at_time,
      } : null,
    delivery_by: !isEmpty(delivery_date) && !isEmpty(delivery_time) ? delivery_date + ' ' + delivery_time : null,
    contact_customer:
      AppConfig.orderContactCustomer[currentOrder.type_of_order],
    first_name: !isEmpty(currentOrder.customer_first_name)
      ? currentOrder.customer_first_name
      : '',
    last_name: !isEmpty(currentOrder.customer_last_name)
      ? currentOrder.customer_last_name
      : '',
    customer_email: currentOrder.customer_email,
    hawb: currentOrder.hawb,
    mawb: currentOrder.mawb,
    nsr:!nsr,
    lh_billing : currentOrder.lh_billing,
    origin_port : currentOrder.origin_port,
    destination_port : currentOrder.destination_port,
    it_number : currentOrder.it_number,
    routing : currentOrder.routing,
    references : currentOrder.references,
    phone_number_one: currentOrder.customer_phone_one,
    phone_number_two: currentOrder.customer_phone_two,
    acc_loc_code: currentOrder.acc_loc_code,
    company_name: currentOrder.company_name,
    customer_details: {
      address_type: !isEmpty (currentOrder.address_type) ? currentOrder.address_type : AppConfig.default_address_type,
      vehicle_type: !isEmpty (currentOrder.vehicle_type) ? currentOrder.vehicle_type : '',
      company_name: !isEmpty(currentOrder.company_name)
        ? currentOrder.company_name
        : '',

      customer_first_name: !isEmpty(currentOrder.customer_first_name)
        ? currentOrder.customer_first_name
        : '',
      customer_last_name: !isEmpty(currentOrder.customer_last_name)
        ? currentOrder.customer_last_name
        : '',
      customer_email: currentOrder.customer_email,
      customer_phone_one: currentOrder.customer_phone_one,
      customer_phone_two: currentOrder.customer_phone_two,
      address: {
        customer_address_line_1: data.csLocation.address_line1,
        customer_address_line_2: data.csLocation.address_line2,
        customer_city: data.csLocation.city,
        customer_state: data.csLocation.state,
        customer_country: currentOrg?.code === "NETMOVE" ? "USA" : data.csLocation.country,
        customer_zipcode: data.csLocation.zipcode,
        acc_loc_code: currentOrder.acc_loc_code,
        id: data?.csLocation?.id ? data.csLocation.id : '',
        is_predefined_loc:currentOrder.is_predefined_loc 
      },
    },
    pallets: currentOrder.pallets,
    // length: currentOrder.length,
    // width: currentOrder.width,
    // height: currentOrder.height,
    surface_area: currentOrder.surface_area,
    notes: currentOrder.notes,
    instructions_from_account_1: currentOrder.instructions_from_account_1,
    instructions_from_account_2: currentOrder.instructions_from_account_2,
    instructions_from_account_3: currentOrder.instructions_from_account_3,
    suppres_schedule_dates: suppres_schedule_dates,
    skip_warn_hawb_uniqness: skip_warn_hawb_uniqness,
    has_expedite: hasExpedite,
    operation_code: 'SCA',
    color_tags: currentOrder.color_tags || [],
    is_multi_driver_delivery: is_multi_driver_delivery,
  }

  if(is_multi_driver_delivery){
    payload.delivery_drivers_count = delivery_drivers_count || 2
  }

  return payload
}

export const setCreatePayload = (
  data,
  currentOrder,
  currentOrg,
  suppres_schedule_dates,
  skip_warn_hawb_uniqness,
  accounts,
  levelOfServices,
  nsr,
  is_multi_driver_delivery,
  delivery_drivers_count
) => { 
  const hasExpedite = isOptedExpedite(data.appointments)
  const reqAccObject = getValueFromArrayOfObjects(accounts, "code" , currentOrder.account_code);
  const reqLOSObject = getValueFromArrayOfObjects(levelOfServices, "code" , currentOrder.los);
  const delivery_date = isMomentObject(currentOrder.delivery_date, currentOrder.delivery_time, "DD-MM-YYYY");
  const delivery_time = isMomentObject(currentOrder.delivery_time, currentOrder.delivery_date, "HH:mm");
  const payload = {
    appointments: data.appointments,
    address_type: !isEmpty (currentOrder.address_type) ? currentOrder.address_type : AppConfig.default_address_type,
    vehicle_type: !isEmpty (currentOrder.vehicle_type) ? currentOrder.vehicle_type : '',
    customer_order_number: !isEmpty(currentOrder.customer_order_number)
      ? currentOrder.customer_order_number.toUpperCase()
      : '',
    private_notes: currentOrder.private_notes,
    quantity: currentOrder.quantity,
    order_weight: currentOrder.weight,
    weight_in_kgs : currentOrder.weight_in_kgs,
    cbm_volume : currentOrder.cbm_volume,
    mileage : currentOrder.mileage,
    warehouse_code: currentOrder.warehouse_code,
    account: currentOrder.account_code,
    los: !isEmpty(currentOrder.los) ? currentOrder.los.toUpperCase() : '',
    account_name: !isEmpty(reqAccObject) ? reqAccObject.name : '',
    account_id: !isEmpty(reqAccObject) ? reqAccObject.id : '',
    los_name: !isEmpty(reqLOSObject) ? reqLOSObject.name : '',
    //los_id: !isEmpty(reqLOSObject) ? reqLOSObject.id : '', // // contarct change
    appt_set: currentOrder.appt_set,
    type_of_order: currentOrder.type_of_order,
    reference_1: currentOrder.reference_1,
    reference_1_type: currentOrder.reference_1_type,
    reference_2: currentOrder.reference_2,
    reference_2_type: currentOrder.reference_2_type,
    is_hazardous: currentOrder.is_hazardous,
    priority : currentOrder.priority,
    special : currentOrder ? currentOrder.special : false,
    consignee_details : currentOrder.consignee_details || {},
    account_manager_emails: !isEmpty(
      currentOrder.account_manager_emails
    )
      ? currentOrder.account_manager_emails
      : "",
    service_duration: !isEmpty(currentOrder.service_duration)
      ? currentOrder.service_duration
      : '',
    received_at: !isEmpty(currentOrder.received_at_date) && !isEmpty(currentOrder.received_at_time) ? {
      date: moment.isMoment(currentOrder.received_at_date) ? currentOrder.received_at_date.format('DD-MM-YYYY') : currentOrder.received_at_date,
      time: moment.isMoment(currentOrder.received_at_time) ? currentOrder.received_at_time.format('HH:mm') : currentOrder.received_at_time,
    } : null,
    delivery_by: !isEmpty(delivery_date) && !isEmpty(delivery_time) ? delivery_date + ' ' + delivery_time : null,
    contact_customer:
      AppConfig.orderContactCustomer[currentOrder.type_of_order],
    company_name: currentOrder.company_name,
    custom_appt_required: currentOrder.custom_appt_required,
    custom_appt_notes: currentOrder.custom_appt_notes,
    customer_comments: currentOrder.customer_comments,
    customer_notes: currentOrder.customer_notes,
    first_name: !isEmpty(currentOrder.customer_first_name)
      ? currentOrder.customer_first_name
      : '',
    last_name: !isEmpty(currentOrder.customer_last_name)
      ? currentOrder.customer_last_name
      : '',
    customer_email: currentOrder.customer_email,
    hawb: currentOrder.hawb,
    mawb: currentOrder.mawb,
    nsr: !nsr,
    origin_port : currentOrder.origin_port,
    destination_port : currentOrder.destination_port,
    it_number : currentOrder.it_number,
    routing : currentOrder.routing,
    references : currentOrder.references,
    phone_number_one: currentOrder.customer_phone_one,
    phone_number_two: currentOrder.customer_phone_two,
    address: {
      company_name: currentOrder?.cs_location?.company_name
        ? currentOrder.cs_location.company_name
        : '',
      customer_address_line_1: data.csLocation.address_line1,
      customer_address_line_2: data.csLocation.address_line2,
      customer_city: data.csLocation.city,
      customer_state: data.csLocation.state,
      customer_country: currentOrg?.code === "NETMOVE" ? "USA" : data.csLocation.country,
      customer_zipcode: data.csLocation.zipcode,
      acc_loc_code: currentOrder.acc_loc_code,
      is_predefined_loc:currentOrder.is_predefined_loc 
    },
    item_name: '',
    notes: currentOrder.notes,
    pallets: currentOrder.pallets,
    // length: currentOrder.length,
    // width: currentOrder.width,
    // height: currentOrder.height,
    surface_area: currentOrder.surface_area,
    instructions_from_account_1: currentOrder.instructions_from_account_1,
    instructions_from_account_2: currentOrder.instructions_from_account_2,
    instructions_from_account_3: currentOrder.instructions_from_account_3,
    suppres_schedule_dates: suppres_schedule_dates,
    has_expedite: hasExpedite,
    operation_code: 'SCA',
    skip_warn_hawb_uniqness: skip_warn_hawb_uniqness,
    driver_id: currentOrder.driver_id,
    lh_billing : currentOrder.lh_billing,
    fleet_id: currentOrder.fleet_id,
    trailer_number: currentOrder.trailer_number,
    color_tags: currentOrder.color_tags || [],
    is_multi_driver_delivery: is_multi_driver_delivery,
  }

  if(is_multi_driver_delivery){
    payload.delivery_drivers_count = delivery_drivers_count || "2"
  }

  return payload
}

export const setLHCreatePayload = (
  data,
  currentOrder,
  currentOrg,
  suppres_schedule_dates,
  skip_warn_hawb_uniqness,
  accounts,
  levelOfServices,
  nsr,
  is_multi_driver_delivery,
  delivery_drivers_count
) => {
  const hasExpedite = isOptedExpedite(data.appointments)
  let pickupLocation = _.find(data.locations, {
    type_of_loc: 'PICKUP',
  })
  const currentLocation = !isEmpty(pickupLocation) ? { ...pickupLocation } : {};
  const reqAccObject = getValueFromArrayOfObjects(accounts, "code" , currentOrder.account_code);
  let reqLOSObject = null;
  if(currentOrder.los){
    reqLOSObject = getValueFromArrayOfObjects(levelOfServices, "code" , currentOrder.los);
    if(reqLOSObject){
      reqLOSObject.los = reqLOSObject.code;
    }
  } else if(pickupLocation){
    reqLOSObject = getValueFromArrayOfObjects(levelOfServices, "code" , pickupLocation.los_code);
    if(reqLOSObject){
      reqLOSObject.los = reqLOSObject.code;
    }
  }
  if(isEmpty(currentLocation.details)){
    currentLocation.details = {}
    currentLocation.l_address = {}
  }
  const locations = _.sortBy(data.locations, "loc_order_sequence");
  const delivery_date = isMomentObject(currentOrder.delivery_date, currentOrder.delivery_time, "DD-MM-YYYY");
  const delivery_time = isMomentObject(currentOrder.delivery_time, currentOrder.delivery_date, "HH:mm");
  const payload = {
    is_multi_driver_delivery: is_multi_driver_delivery,
    customer_order_number: !isEmpty(currentOrder.customer_order_number)
      ? currentOrder.customer_order_number.toUpperCase()
      : '',
    lh_order_ids: currentOrder?.lh_orders ? currentOrder.lh_orders.map(order => order.id) : [],
    address_type: !isEmpty (currentOrder.address_type) ? currentOrder.address_type : AppConfig.default_address_type,
    vehicle_type: !isEmpty (currentOrder.vehicle_type) ? currentOrder.vehicle_type : '',
    private_notes: currentOrder.private_notes,
    quantity: currentOrder.quantity,
    order_weight: currentOrder.weight,
    weight_in_kgs: currentOrder.weight_in_kgs,
    cbm_volume : currentOrder.cbm_volume,
    mileage: currentOrder.mileage,
    warehouse_code: currentOrder.warehouse_code,
    account: currentOrder.account_code,
    account_name: !isEmpty(reqAccObject) ? reqAccObject.name : '',
    account_id: !isEmpty(reqAccObject) ? reqAccObject.id : '',
    los_name: !isEmpty(reqLOSObject) ? reqLOSObject.name : '',
    //los_id: !isEmpty(reqLOSObject) ? reqLOSObject.id : '', // contarct change
    los: reqLOSObject && !isEmpty(reqLOSObject.los) ? reqLOSObject.los.toUpperCase() : '',
    appt_set: currentOrder.appt_set,
    type_of_order: currentOrder.type_of_order,
    reference_1: currentOrder.reference_1,
    reference_1_type: currentOrder.reference_1_type,
    reference_2: currentOrder.reference_2,
    reference_2_type: currentOrder.reference_2_type,
    is_hazardous: currentOrder.is_hazardous,
    priority : currentOrder.priority,
    special : currentOrder ? currentOrder.special : false,
    consignee_details:  currentOrder.consignee_details || {},
    account_manager_emails: !isEmpty(
      currentOrder.account_manager_emails
    )
      ? currentOrder.account_manager_emails
      : "",
    service_duration: !isEmpty(currentOrder.service_duration)
      ? currentOrder.service_duration
      : '',
    received_at: !isEmpty(currentOrder.received_at_date) && !isEmpty(currentOrder.received_at_time) ? {
        date: moment.isMoment(currentOrder.received_at_date) ? currentOrder.received_at_date.format('DD-MM-YYYY') : currentOrder.received_at_date,
        time: moment.isMoment(currentOrder.received_at_time) ? currentOrder.received_at_time.format('HH:mm') : currentOrder.received_at_time,
      } : null,
    delivery_by: !isEmpty(delivery_date) && !isEmpty(delivery_time) ? delivery_date + ' ' + delivery_time : null,
    contact_customer:
      AppConfig.orderContactCustomer[currentOrder.type_of_order],
    company_name: currentLocation.details.company_name,
    acc_loc_code : currentLocation.details.acc_loc_code,
    has_recovery  : locations.filter((loc) => loc?.details?.is_recovery === true).length > 0,
    has_release  : locations.filter((loc) => loc?.details?.is_release === true).length > 0,
    custom_appt_required: currentOrder.custom_appt_required,
    custom_appt_notes: currentOrder.custom_appt_notes,
    customer_comments: currentOrder.customer_comments,
    customer_notes: currentOrder.customer_notes,
    first_name: !isEmpty(currentLocation.details.customer_first_name)
      ? currentLocation.details.customer_first_name
      : '',
    last_name: !isEmpty(currentLocation.details.customer_last_name)
      ? currentLocation.details.customer_last_name
      : '',
    customer_email: currentLocation.details.customer_email,
    phone_number_one: currentLocation.details.customer_phone_one,
    phone_number_two: currentLocation.details.customer_phone_two,
    hawb: currentOrder.hawb,
    references :currentOrder.references,
    mawb: currentOrder.mawb,
    nsr: !nsr,
    origin_port : currentOrder.origin_port,
    destination_port : currentOrder.destination_port,
    it_number : currentOrder.it_number,
    routing : currentOrder.routing,
    address: {
      company_name: !isEmpty(currentLocation.details.company_name)
        ? currentLocation.details.company_name
        : '',
      acc_loc_code: !isEmpty(currentLocation.details.acc_loc_code) ?
      currentLocation.details.acc_loc_code : "",   
      customer_address_line_1: currentLocation.l_address.address_line1,
      customer_address_line_2: currentLocation.l_address.address_line2,
      customer_city: currentLocation.l_address.city,
      customer_state: currentLocation.l_address.state,
      customer_country: currentOrg?.code === "NETMOVE" ? "USA" : currentLocation.l_address.country,
      customer_zipcode: currentLocation.l_address.zipcode,
      id: currentOrder.id? currentLocation.id : '',
    },
    item_name: '',
    notes: currentOrder.notes,
    pallets: currentOrder.pallets,
    // length: currentOrder.length,
    // width: currentOrder.width,
    // height: currentOrder.height,
    surface_area: currentOrder.surface_area,
    instructions_from_account_1: currentOrder.instructions_from_account_1,
    instructions_from_account_2: currentOrder.instructions_from_account_2,
    instructions_from_account_3: currentOrder.instructions_from_account_3,
    suppres_schedule_dates: suppres_schedule_dates,
    has_expedite: hasExpedite,
    operation_code: 'SCA',
    skip_warn_hawb_uniqness: skip_warn_hawb_uniqness,
    driver_id: currentOrder.driver_id,
    lh_billing : currentOrder.lh_billing,
    fleet_id: currentOrder.fleet_id,
    trailer_number: currentOrder.trailer_number,
    source_wh: currentOrder.source_wh,
    color_tags: currentOrder.color_tags || [],
    locations: locations.map((loc, index) => {
      const reqLOSObject = getValueFromArrayOfObjects(levelOfServices, "code" , loc.los_code);

      return (
        {
      ...loc.details,
      is_recovery: loc?.details?.is_recovery === true,
      is_multi_driver_delivery: loc?.details?.is_multi_driver_delivery === true,
      delivery_drivers_count: loc?.details?.delivery_drivers_count ? loc.details.delivery_drivers_count : 2,
      recovery_status: loc?.details?.recovery_status ? loc.details.recovery_status : '',
      is_release: loc?.details?.is_release === true,
      is_predefined_loc:loc?.details?.is_predefined_loc  ,
      release_status: loc?.release_status ? loc.release_status : '',
      customer_address_line_1: loc.l_address.address_line1,
      customer_address_line_2: loc.l_address.address_line2,
      customer_city: loc.l_address.city,
      customer_state: loc.l_address.state,
      customer_country: currentOrg?.code === "NETMOVE" ? "USA" : loc.l_address.country,
      customer_zipcode: loc.l_address.zipcode,
      acc_loc_code : loc.details.acc_loc_code,
      appointments: loc.appointments,
      operational_use: loc.details?.operational_use || loc.operational_use || "FINAL_MILE",
      type_of_loc: loc.type_of_loc,
      l_type: loc.details?.l_type ? loc.details.l_type : 'CS',
      service_duration: loc?.service_duration ? loc.service_duration : 0,
      weight: loc?.weight ? parseInt(loc.weight, 10) : 0,
      quantity: loc?.quantity ? parseInt(loc.quantity, 10) : 0,
      pallets: loc?.pallets ? parseInt(loc.pallets, 10) : 0,
      surface_area: loc?.surface_area ? parseInt(loc.surface_area, 10) : 0,
      los_code: currentOrder.type_of_order === "MS" ? currentOrder.los : loc?.los_code ? loc.los_code.toUpperCase(): (
        !isEmpty(currentOrder.los) ? currentOrder.los.toUpperCase() : ''
      ),
      los_name: !isEmpty(reqLOSObject) ? reqLOSObject.name : '',
      // los_id: !isEmpty(reqLOSObject) ? reqLOSObject.id : '', // contract change
      loc_order_sequence: index,
        }
      );
    }),
    destination_wh: currentOrder.destination_wh,
  }

  if(currentOrder.id){
    payload.id = currentOrder.id;
  }
  return payload
}

export const validateOrder = (details, index, currentOrder, requiredFields, orderRequiredFields) => {
  const errors = []
  let validationErrors = [];
  currentOrder.customer_phone_one = formatePhoneNo(
    currentOrder.customer_phone_one,
  )
  currentOrder.customer_phone_two = formatePhoneNo(
    currentOrder.customer_phone_two,
  )
  const appointments = []
  const accessorials = []
  const preferences = currentOrder.preferences || []
  const accountAccessorials = currentOrder.accountAccessorials || []
  const orderAccessorials = currentOrder.orderAccessorials || []
  let i = 0
  if (preferences.length > 0) {
    preferences.forEach((preference) => {
      if (
        preference.item_preference &&
        preference.item_option.length > 0 &&
        (!preference.item_option.includes('CUSTOM') ||
          (preference.item_option.includes('CUSTOM') &&
            !isEmpty(preference.start_time) &&
            !isEmpty(preference.end_time)))
      ) {
        i += 1
        const slots = preference.item_option ? preference.item_option : []
        appointments.push(
          Object.assign(
            {},
            {
              // s_no: i,
              appt_date: moment(preference.item_preference).format(
                'YYYY-MM-DD 00:00:00',
              ),
              slots,
              confirmed: preference.confirmed,
              has_expedite: preference.has_expedite === true,
              start_time:
                slots.includes('CUSTOM') && preference.start_time
                  ? moment(preference.start_time).format('HH:mm')
                  : '',
              end_time:
                slots.includes('CUSTOM') && preference.end_time
                  ? moment(preference.end_time).format('HH:mm')
                  : '',
            },
          ),
        )
      } else if (
        preference.item_option.includes('CUSTOM') &&
        (isEmpty(preference.start_time) || isEmpty(preference.end_time))
      ) {
        if (!preference.start_time) {
          // ${preference.s_no}
          errors.push(
            `In ${details.label} details, ${I18n.t(
              'messages.appointment_form.validation',
            )}  From time`,
          )
        } else {
          errors.push(
            `In ${details.label} details, ${I18n.t(
              'messages.appointment_form.validation',
            )} To Time`,
          )
        }
      } else if (
        preference.item_preference ||
        preference.item_option.length > 0 ||
        preference.confirmed
      ) {
        if (!preference.item_preference) {
          errors.push(
            `In ${details.label} details, ${I18n.t(
              'messages.appointment_form.validation',
            )} date`,
          )
        } else {
          errors.push(
            `In ${details.label} details, ${I18n.t(
              'messages.appointment_form.validation',
            )} time slot`,
          )
        }
      }
    })

    if (appointments.length > 0) {
      /* const confirmedAppointments = appointments.filter(appointment => appointment.confirmed === true);
            if (confirmedAppointments.length === 0) {
              errors.push(`${I18n.t('messages.appointment_form.confirm_appt_message')}`);
            } */
    }
  }
  orderAccessorials.forEach((accessorial) => {
    const accIndex = _.findIndex(accountAccessorials, [
      'accessorial_key',
      accessorial,
    ])
    if (accIndex >= 0) {
      // if (
      //   accountAccessorials[accIndex].accessorial_type !== "los" &&
      //   accountAccessorials[accIndex].input_type &&
      //   isEmpty(accountAccessorials[accIndex].inputValue)
      // ) {
      //   errors.push(
      //     `In ${
      //       details.label
      //     } details, Value is required for the ${I18n.t(
      //       "order.accessorial"
      //     )} ${accountAccessorials[accIndex].name}`
      //   );
      // }
      accessorials.push({
        item_id: '',
        accessorial_key: accessorial,
        code: accountAccessorials[accIndex].code,
        accessorial_value: accountAccessorials[accIndex].inputValue || '',
        accessorial_type: accountAccessorials[accIndex].accessorial_type || '',
      })
    }
  })

  if (isEmpty(currentOrder.type_of_order)) {
    currentOrder.type_of_order = details.type_of_order
  }

  let allRequiredFields = [...requiredFields]
  // if (
  //   this.state.config[
  //     I18n.t("configurations.move_to_exception_on_invalid_number")
  //   ] === "true"
  // ) {
  //   allRequiredFields = [].concat(allRequiredFields, mobileFields);
  // }

  const customerErrors = doValidate(
    allRequiredFields,
    currentOrder,
    `In ${details.label} details, `,
  )
  let orderErrors = []
  if (index === 0) {
    orderErrors = doValidate(orderRequiredFields, currentOrder)
  }
  const csLocation =
    currentOrder.cs_location && currentOrder.cs_location.l_address
      ? currentOrder.cs_location.l_address
      : {}
  const addressErrors = validateAddressForm(csLocation)
  validationErrors = [].concat(
    validationErrors,
    orderErrors,
    errors,
    customerErrors,
    !isEmpty(addressErrors)
      ? [`${addressErrors} in ${details.label} Address`]
      : [],
  )

  // if (index === 0) {
  //   if (!isEmpty(currentOrder.reference_1_type)) {
  //     if (isEmpty(currentOrder.reference_1)) {
  //       validationErrors.push(
  //         `${I18n.t("order.reference_value")} 1 is required`
  //       );
  //     }
  //   }
  //   if (!isEmpty(currentOrder.reference_2_type)) {
  //     if (isEmpty(currentOrder.reference_2)) {
  //       validationErrors.push(
  //         `${I18n.t("order.reference_value")} 2 is required`
  //       );
  //     }
  //   }
  // }

  return validationErrors
}


// renderOrderPics = (orderType, locationIndex) => {
//     const { formData } = this.state
//     const currentOrder = _.cloneDeep(formData[orderType])
//     const signatureImgs = []
//     const printPics = []
//     const pictures = []
//     let orderPictures = []
//     let currentLocation = {};
//     let dataObject = currentOrder
//     if(currentOrder.is_location_based) {
//       currentLocation = currentOrder.locations && currentOrder.locations.length >= locationIndex ? currentOrder.locations[locationIndex] : {};
//       dataObject = currentLocation
//     }
//     orderPictures = dataObject.pictures || []
//     let signatureObject = {}
//     if (orderPictures.length > 0) {
//       orderPictures.forEach((pic) => {
//         if (pic.picture && pic.picture.url) {
//           const formattedImage = pic.picture.url
//           if (pic.image_type === 'normal') {
//             pictures.push(formattedImage)
//           } else if (pic.image_type === 'signature') {
//             signatureImgs.push(formattedImage)
//             signatureObject = pic
//           } else if (pic.image_type === 'print') {
//             printPics.push(formattedImage)
//           }
//         }
//       })
//     }
//     const signature = signatureImgs.length > 0 ? signatureImgs[0] : ''
//     const { isMilitaryTime } = this.state
//     return (
//       <Card
//         size="small"
//         title={I18n.t('general.pod')}
//         extra={
//           checkServiceExistance('NRASOP') ? (
//             <Tooltip title={I18n.t('order.upload_images')}>
//               <img
//                 src={photoIcon}
//                 onClick={() => this.imageAction(orderType, currentLocation)}
//                 style={{ width: 20, height: 20 }}
//                 alt="upload"
//                 className="marginRight5"
//               />
//             </Tooltip>
//           ) : (
//             <Fragment />
//           )
//         }
//       >
//         <Legs
//           pictures={pictures}
//           signature={signature}
//           pagination={{ position: 'none' }}
//           size="small"
//           showType="seperate"
//           imageAction={() => this.imageAction(orderType)}
//           currentLocation={currentLocation}
//         />
//         {!isEmpty(signatureObject) &&
//           _.isObject(signatureObject) &&
//           signatureObject.sign_by && (
//             <Fragment>
//               <Row>
//                 <Col xs={24}>
//                   <h4 className="alignLeft">
//                     {I18n.t('order.sign_by')}{' '}
//                     <span className="textCaptilize">
//                       {signatureObject.sign_by}
//                     </span>{' '}
//                     {!isEmpty(signatureObject.title_by_relation) && (
//                       <span className="textCaptilize">
//                         ( {signatureObject.title_by_relation} )
//                       </span>
//                     )}
//                     {signatureObject.captured_at
//                       ? ` at ${formatByTimeConfig(
//                           moment(signatureObject.captured_at),
//                           isMilitaryTime,
//                           'Do MMM YYYY, HH:mm',
//                           'Do MMM YYYY, hh:mm A',
//                         )} ${
//                           currentOrder.order_tz_short_name
//                             ? ` ${currentOrder.order_tz_short_name}`
//                             : ''
//                         }`
//                       : ''}
//                   </h4>
//                 </Col>
//               </Row>
//             </Fragment>
//           )}
//       </Card>
//     )
//   }



export const checkIsFilled = (locData, skipFields = []) => {
  const requiredFields = [
  "los_code", "company_name", "customer_email",
  "customer_address_line_1", "customer_address_line_2", "customer_city", "customer_state", "customer_country",
  "customer_zipcode","customer_phone_one","customer_phone_two", "address_type",
  "customer_first_name" ,
  {
    key: "appointment",
    fields: ["appt_date", "start_time", "end_time", "slot"],
  }
]

  // Function to check if all fields in an object are filled
  const areFieldsFilled = (data, fields) => {
    return fields.some(
      (field) => !isEmpty(data[field])
    );
  };

  const isAnyThingFilled = (_.difference(requiredFields, skipFields)).some((field) => {
    if (typeof field === "string") {
      return !_.isEmpty(locData[field]);
    } else if (field?.key && field?.fields) {
      if (isEmpty(locData[field.key] )) {
        return false;
      }
      return areFieldsFilled(locData[field.key], field.fields);
    }
  });

  let isLocValid = isAnyThingFilled;

  if (
    (!isAnyThingFilled && (locData.service_duration?.length > 0 || locData?.has_expedite === true))
  ) {
    isLocValid = true;
  }

  return isLocValid;
};


// Function to compare two appointments (considering both date and start time)
const compareAppointments = (a, b) => {
  const aDateTime = moment(a.appt_date).set({
    hour: parseInt(a.start_time.split(':')[0]),
    minute: parseInt(a.start_time.split(':')[1]),
    second: 0,
    millisecond: 0
  });

  const bDateTime = moment(b.appt_date).set({
    hour: parseInt(b.start_time.split(':')[0]),
    minute: parseInt(b.start_time.split(':')[1]),
    second: 0,
    millisecond: 0
  });

  return bDateTime.isSameOrAfter(aDateTime);
};

// Helper function to validate if an appointment has both date and time
const isValidAppointment = (appt) => {
  return appt.appt_date && appt.start_time;
};

// Function to check if all locations' appointments are in the correct sequence
export const areAppointmentsInOrder = (locationsInfo) => {
  let errors = [];
  let previousValidAppointment = null;

  const locations = _.compact(locationsInfo)
  for (let i = 0; i < locations.length; i++) {
    const currLocation = locations[i];
    const { appointment } = currLocation;
    const nextLocsHaveappointments = locationsInfo.filter((loc, index) => index > i && loc?.appointment && (loc?.appointment?.appt_date || loc?.appointment?.start_time)).length > 0

    if((!appointment || (!appointment?.appt_date && !appointment?.start_time)) && !nextLocsHaveappointments) {
      continue;
    }

    // Ignore locations with missing or incomplete appointment data
    if (!appointment && !appointment?.appt_date && !appointment?.start_time) {
      errors.push(`Location ${i + 1}: Both ` + I18n.t("general.appointment") + ` Date & Slots are required`);
      continue; // Skip this entry if both fields are missing
    }

    // If one field is missing but the other is present, it's invalid
    if (!isValidAppointment(appointment)) {
      errors.push(`Location ${i + 1}: Both ` + I18n.t("general.appointment") + ` Date & Slots are required`);
      continue; // Skip further checks for this invalid appointment
    }

    // If the current location is valid and there's a previous valid one, compare
    if (previousValidAppointment?.appointment) {
      if (!compareAppointments(previousValidAppointment.appointment, currLocation.appointment)) {
        errors.push(`Location ${i + 1}'s appointment should be greater or equal to Location ${i}`);
      }
    }

    // Update previous valid appointment to current location
    previousValidAppointment = currLocation;
  }

  return errors.length ? errors : []; // Return errors if any, or null if no errors
};

export const validateLtlOnHandTimes = (locationsInfo = [], isLtlOrg = false, orderType) => {
  if (!isLtlOrg || !showLtlOnHandFields({ is_ltl: true }, orderType)) return [];

  const locations = _.compact(Array.isArray(locationsInfo) ? locationsInfo : []);
  const pickup = locations.find((loc) => loc?.type_of_loc === "PICKUP");
  const delivery = locations.find((loc) => loc?.type_of_loc === "DELIVERY");
  const pickupDate = pickup?.on_hand_datetime ? moment(pickup.on_hand_datetime) : null;
  const deliveryDate = delivery?.on_hand_datetime ? moment(delivery.on_hand_datetime) : null;
  const pickupValid = pickupDate && pickupDate.isValid();
  const deliveryValid = deliveryDate && deliveryDate.isValid();

  if (!pickupValid && !deliveryValid) return [];
  if (deliveryValid && !pickupValid && pickup) {
    return [I18n.t("messages.on_hand_pickup_required")];
  }
  if (pickupValid && deliveryValid && !deliveryDate.isAfter(pickupDate)) {
    return [I18n.t("messages.on_hand_destination_after_pickup")];
  }
  return [];
};

export const isMultiDayOrder = (locations) => {
  if(locations?.length < 2){
    return false;
  }
  const uniqDates = locations.filter(loc => loc?.appointment?.appt_date)
  .map(loc => moment(loc.appointment.appt_date).format("YYYY-MM-DD"));

  if(_.uniq(_.compact(uniqDates)).length > 1){
    return true;
  }
  return false;
}

export const formatOrderApiResponse = (data, modeType = "view") => {

  const concatNotes = () => {
    let notes = _.get(data, 'notes', "") || "";
    if(data?.instructions_from_account_1){
      notes = `${notes} ${data.instructions_from_account_1}`
    }
    if(data?.instructions_from_account_2){
      notes = `${notes} ${data.instructions_from_account_2}`
    }
    if(data?.instructions_from_account_3){
      notes = `${notes} ${data.instructions_from_account_3}`
    }
    return notes;
    
  }

  const formataddress = (selectedAddress) => {
    return ({
    company_name: selectedAddress.company_name,
    customer_email: selectedAddress.email,
    customer_address_line_1: selectedAddress?.address?.address_line1 || '',
    customer_address_line_2: selectedAddress?.address?.address_line2 || '',
    customer_city: selectedAddress?.address?.city || "",
    customer_state: selectedAddress?.address?.state || "",
    customer_country: selectedAddress?.address?.country || "",
    customer_zipcode: selectedAddress?.address?.zipcode || "",
    address_type: selectedAddress?.address_type || "COMMERCIAL",
    operational_use: selectedAddress?.operational_use || "FINAL_MILE",
    customer_phone_one: selectedAddress.phone,
    customer_phone_two: selectedAddress.phone_2,
    customer_first_name: selectedAddress.first_name || selectedAddress.name,
    l_type: selectedAddress?.l_type,
    label_code: selectedAddress.location_label,
    type_of_loc: selectedAddress?.type_of_loc ? selectedAddress.type_of_loc : "",
    })
  }



  const orderResponse = {
    ...data,
    notes: concatNotes(),
    account:{
      ...data.account,
      id: data?.account?.account_id || '',
    },  
    customer_order_details:{
      ...data.customer_order_details,
      id: data?.customer_order_details?.customer_order_id || "",
      account_id: data?.account?.account_id || '',
    },
    locations:[],
    order_quotations: [],

    id: data?.customer_order_details?.customer_order_id || '',
    ..._.pick(data?.customer_order_details, ['status', 'type_of_order', 'customer_order_number', 'hawb', 'mawb']),
    order_number: data?.customer_order_details?.customer_order_number || '',
    target_warehouse: data?.customer_order_details?.target_warehouse || '',
    label_code: data?.customer_order_details?.order_label || '',
  }

  if (modeType === "full_edit") {
    const isMoveOrder = ["SDR", "SDD", "MDR", "MDD"].includes(data?.customer_order_details?.order_label)
    orderResponse.customer_order_details = {
      ...orderResponse.customer_order_details,
      type_of_order: isMoveOrder ? "M" : data?.customer_order_details?.type_of_order,
      order_label: isMoveOrder ? "M" : data?.customer_order_details?.order_label,
      label_code: isMoveOrder ? "M" : data?.customer_order_details?.order_label,
    }
    if (isMoveOrder) {
      orderResponse.related_order_details = {
        ...data.related_order_details,
        type_of_order: isMoveOrder ? "M" : data?.related_order_details?.type_of_order,
        order_label: isMoveOrder ? "M" : data?.related_order_details?.order_label,
      }
      orderResponse.pickup_location_details = {
        ...data.pickup_location_details
      }
      orderResponse.delivery_location_details = {
        ...data.delivery_location_details
      }
    }
  }
  
  orderResponse.order_label = orderResponse.customer_order_details.order_label
  orderResponse.is_deleted_order = orderResponse?.customer_order_details?.is_deleted_order

  if(data?.pickup_location_details){
    orderResponse.locations.push(
      {  ...data.pickup_location_details, 
        id: (data.pickup_location_details?.location_id || ''), 
        label_name: getLabelDescriptionForLocation(data.pickup_location_details?.location_label, orderResponse.order_label),
        appointment: _.get(data.pickup_location_details, "appointments[0]"),
        label_code: data.pickup_location_details?.location_label || '',
        ...formataddress(data.pickup_location_details)

     })
  } 
  if(data?.delivery_location_details){
    orderResponse.locations.push({...data.delivery_location_details, id: (data.delivery_location_details?.location_id || ''),
    label_name: getLabelDescriptionForLocation(data.delivery_location_details?.location_label, orderResponse.order_label),
    appointment: _.get(data.delivery_location_details, "appointments[0]"),
    label_code: data.delivery_location_details?.location_label || '',
    ...formataddress(data?.delivery_location_details)
   })
  }

  if(orderResponse.type_of_order === "MS" && data.locations?.length){
    orderResponse.locations = data.locations.map(loc => ({
      ...loc,
      id: (loc?.location_id || ''),
      label_name: getLabelDescriptionForLocation(loc?.location_label),
      appointment: _.get(loc, "appointments[0]"),
      label_code: loc?.location_label || 'R',
      ...formataddress(loc)
    }))
    orderResponse.order_items = data?.order_items?.map(item => ({
      ...item,
      pickup_loc_seq: getValueFromArrayOfObjects(data.locations, "location_id", item.pick_up_location_id, "loc_order_sequence" ),
      delivery_loc_seq: getValueFromArrayOfObjects(data.locations, "location_id", item.drop_location_id, "loc_order_sequence" ),
    }))
  }
  orderResponse.order_quotations = data?.order_quotations || []
  // if(data?.order_quotations?.pickup_quotation){
  //   orderResponse.order_quotations.push({
  //     ...data.order_quotations.pickup_quotation,
  //     type_of_loc: 'PICKUP',
  //   })
  // }
  // if(data?.order_quotations?.delivery_quotation){
  //   orderResponse.order_quotations.push({
  //     ...data.order_quotations.delivery_quotation,
  //     type_of_loc: 'DELIVERY',
  //   })
  // }
  return orderResponse;
};

const LINEHAUL_ORDER_CODES = ["LH", "NLH", "PLH", "LHD", "PLHD"];

const hasLinehaulTariff = (tariff) => {
  if (typeof tariff === "string") return tariff.trim().length > 0;
  if (!tariff || typeof tariff !== "object") return false;
  return Boolean(tariff.los_id || tariff.los_code || tariff.los_name);
};

const formatLinehaulLegName = (leg, index) => {
  const origin = String(leg?.origin_code || "").trim().toUpperCase();
  const destination = String(leg?.destination_code || "").trim().toUpperCase();
  if (origin && destination) return `${origin}-${destination}`;
  return `leg ${index + 1}`;
};

export const getLinehaulRouteValidationError = (tracking, { isLinehaulOrder = true } = {}) => {
  if (!isLinehaulOrder) return null;
  if (!tracking) return null;

  const legs = Array.isArray(tracking.legs) ? tracking.legs : [];
  const hasRoute = Boolean(tracking.path_id) || legs.length > 0;
  if (!hasRoute) return null;

  if (!hasLinehaulTariff(tracking.tariff)) {
    return "Tariff is required.";
  }

  let previousDate = null;
  let previousIndex = -1;
  for (let i = 0; i < legs.length; i += 1) {
    const rawDate = legs[i]?.linehaul_service_date;
    if (!rawDate) continue;
    const currentDate = moment(rawDate);
    if (!currentDate.isValid()) continue;

    if (previousDate && currentDate.clone().startOf("day").isBefore(previousDate, "day")) {
      const currentLeg = formatLinehaulLegName(legs[i], i);
      const previousLeg = formatLinehaulLegName(legs[previousIndex], previousIndex);
      return `The ${currentLeg} service date (${currentDate.format("MMM D")}) cannot be earlier than the previous leg ${previousLeg} (${previousDate.format("MMM D")}).`;
    }
    previousDate = currentDate.clone().startOf("day");
    previousIndex = i;
  }

  return null;
};

export const isLinehaulOrderCode = (code) => LINEHAUL_ORDER_CODES.includes(code);
